


// plp grid toggle for the two and 4 grid
document.addEventListener('DOMContentLoaded', function () {
    const gridTabs = document.querySelectorAll('.grid-tab a');
    const productGrid = document.getElementById('ProductGridContainer');

    gridTabs.forEach(tab => {
      tab.addEventListener('click', function (e) {
        e.preventDefault();

        const gridType = this.getAttribute('data-rel');

        // Remove 'active' class from all tabs
        gridTabs.forEach(t => t.classList.remove('active'));

        // Add 'active' to the clicked tab
        this.classList.add('active');

        if (gridType === 'fourgrid') {
          // Remove 'two-row-active-grid' class
          productGrid.classList.remove('two-row-active-grid');
        } else if (gridType === 'twogrid') {
          // Add 'two-row-active-grid' class
          productGrid.classList.add('two-row-active-grid');
        }
      });
    });
  });



// cart cupon discount.

document.addEventListener("DOMContentLoaded", function () {
  const clearBtn = document.querySelector("#clear-discount-btn");
  const applyBtn = document.querySelector("#apply-discount-btn");
  const discountCodeError = document.querySelector("#discount-code-error");
  // const discountCodeWrapper = document.querySelector(".applied-discount-code-wrapper");
  // const discountCodeValue = document.querySelector(".applied-discount-code-value");
  const discountCodeInput = document.querySelector("#discount-code-input");
  const totalCartSelector = document.querySelector(".cart__subtotal .money");

  if (localStorage.discountCode) {
    const stored = JSON.parse(localStorage.discountCode);
    showDiscount(stored.code);
  }
  
  applyBtn?.addEventListener("click", function (e) {
    e.preventDefault();
    const code = discountCodeInput.value.trim();
    if (!code) {
      discountCodeError.textContent = "Please enter a discount code.";
      return;
    }
    applyDiscount(code);
  });

  clearBtn?.addEventListener("click", function (e) {
    e.preventDefault();
    clearDiscount();
  });

  function applyDiscount(code) {
    applyBtn.innerHTML = `<svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.4" fill-rule="evenodd" clip-rule="evenodd" d="M8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33333 8 1.33333C4.3181 1.33333 1.33333 4.3181 1.33333 8C1.33333 11.6819 4.3181 14.6667 8 14.6667ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z" fill="#AAAAAA"/><path d="M15.3326 8C15.7008 8 16.0029 7.70101 15.9722 7.3341C15.9035 6.51168 15.7079 5.70346 15.391 4.93853C14.989 3.96793 14.3997 3.08601 13.6569 2.34315C12.914 1.60028 12.0321 1.011 11.0615 0.608964C10.2965 0.292118 9.48832 0.0964565 8.6659 0.0277617C8.29899 -0.00288556 8 0.299188 8 0.667378C8 1.03557 8.29921 1.3313 8.66556 1.36807C9.31253 1.433 9.94774 1.59237 10.5507 1.84212C11.3593 2.17708 12.0941 2.66804 12.713 3.28696C13.332 3.90589 13.8229 4.64066 14.1579 5.44932C14.4076 6.05226 14.567 6.68747 14.6319 7.33444C14.6687 7.70079 14.9644 8 15.3326 8Z" fill="#010101"/></svg>`;
    applyBtn.disabled = true;
    discountCodeError.innerHTML = '';
    var isApplied = false;
    fetch(`/discount/${encodeURIComponent(code)}?redirect=/cart`)
      .then(() => {
        code = code.toLowerCase();
        fetch('/cart.js').then((response) => response.json()).then((response)=>{
          response.items.forEach(function(item){
            window.LOTTO_DEBUG&&console.log(item.discounts);
            item.discounts.forEach(function(discount){
              if(discount.title.toLowerCase() == code){
                isApplied = true;
              }
            })
          });
          
          response.cart_level_discount_applications.forEach(function(item){
            if(item.title.toLowerCase() == code){
              isApplied = true;
            }
          });
            
            localStorage.setItem("discountCode", JSON.stringify({ code }));
          if(isApplied === true){
            showDiscount(code);  
          }else{
            discountCodeError.innerHTML = 'This code is invalid or not valid for these items.';
          }
          if(isApplied === true){
            refreshCartBoxSection();  
          }else{
            applyBtn.innerHTML = "APPLY";
            applyBtn.disabled = false;
          }
          
        })
        
      })
      .catch(() => {
        discountCodeError.textContent = "Failed to apply discount.";
        hideDiscount();
        localStorage.removeItem("discountCode");
      })
      .finally(() => {
        // applyBtn.innerHTML = "APPLY";
        // applyBtn.disabled = false;
        
      });
  }

    function clearDiscount() {
    fetch('/cart/update', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({discount:''}) })
      .then(() => {
        hideDiscount();
        localStorage.removeItem("discountCode");
        refreshCartBoxSection();
      });
    //   .then(() => fetch('/cart.js'))
    //   .then(res => res.json())
    //   .then(cart => {
    //     hideDiscount();
    //     localStorage.removeItem("discountCode");
    //     refreshCartBoxSection();
    // });
  }

  function showDiscount(code) {
    // if (discountCodeWrapper) discountCodeWrapper.style.display = "inline";
    // if (discountCodeValue) discountCodeValue.textContent = code;
    if (discountCodeError) discountCodeError.textContent = "";
  }

  function hideDiscount() {
    // if (discountCodeWrapper) discountCodeWrapper.style.display = "none";
    // if (discountCodeValue) discountCodeValue.textContent = "";
    if (discountCodeError) discountCodeError.textContent = "";
  }
function refreshCartBoxSection() {
  window.location.reload();
}
// function refreshCartBoxSection() {
//   window.LOTTO_DEBUG&&console.log("⏳ Starting cart section refresh...");

//   const cartLeft = document.querySelector('#main-cart-items');
//   const cartRight = document.querySelector('#main-cart-summery');
//   cartLeft?.classList.add('loading');
//   cartRight?.classList.add('loading');

//   const url = window.location.pathname + '?section_id=custom-cart-full';
//   window.LOTTO_DEBUG&&console.log("📡 Fetching from:", url);

//   fetch(url)
//     .then(res => res.text())
//     .then(html => {
//       window.LOTTO_DEBUG&&console.log("📥 Response HTML received");

//       const parser = new DOMParser();
//       const doc = parser.parseFromString(html, 'text/html');

//       const newCartLeft = doc.querySelector('#main-cart-items');
//       const newCartRight = doc.querySelector('#main-cart-summery');

//       if (newCartLeft && cartLeft) {
//         window.LOTTO_DEBUG&&console.log("🔁 Replacing cart-left");
//         cartLeft.replaceWith(newCartLeft);
//       } else {
//         console.warn("❌ cart-left not found in update.");
//       }

//       if (newCartRight && cartRight) {
//         window.LOTTO_DEBUG&&console.log("🔁 Replacing cart-right");
//         cartRight.replaceWith(newCartRight);
//       } else {
//         console.warn("❌ cart-right not found in update.");
//       }
//     })
//     .catch(err => {
//       console.error("🚨 Error refreshing cart section:", err);
//     });
// }

// function refreshCartBoxSection() {
//   window.LOTTO_DEBUG&&console.log("⏳ Starting cart box refresh...");

//   const existingCartBox = document.querySelector('.cart-box');
//   if (existingCartBox) existingCartBox.classList.add('loading');

//   const url = window.location.pathname + '?section_id=custom-cart-full';
//   window.LOTTO_DEBUG&&console.log("📡 Fetching from:", url);

//   fetch(url)
//     .then(res => res.text())
//     .then(html => {
//       window.LOTTO_DEBUG&&console.log("📥 Response HTML:", html);

//       const parser = new DOMParser();
//       const doc = parser.parseFromString(html, 'text/html');

//       const newCartBox = doc.querySelector('.cart-box');
//       const existingCartBox = document.querySelector('.cart-box');

//       window.LOTTO_DEBUG&&console.log("🧪 Parsed new cart-box:", newCartBox);
//       window.LOTTO_DEBUG&&console.log("🧪 Existing cart-box:", existingCartBox);

//       if (newCartBox && existingCartBox) {
//         window.LOTTO_DEBUG&&console.log("🔁 Replacing cart box...");
//         existingCartBox.replaceWith(newCartBox);
//       } else {
//         console.warn("❌ Could not find one of the cart-box elements.");
//       }
//     })
//     .finally(() => {
//       const updatedCartBox = document.querySelector('.cart-box');
//       updatedCartBox?.classList.remove('loading');
//     })
//     .catch(err => console.error("🚨 Error refreshing cart section:", err));
// }

  
})






















// $(document).ready(function () {
//   // Remove active class from .size-guide on page load
//   $('.size-guide').removeClass('active');

//   // Bind core UI events
//   $(document).on('click', '.product-details_seclect-size', function () {
//     $('.product-details_add-cart').addClass('active');
//     $('#size-btn-container').addClass('active');
//     $('.size-guide').addClass('active');
//     $(this).removeClass('active');
//     document.querySelector('.estimatedDeliveryWrapper').style.display = 'block';
    
    
//   });

//   $(document).on('change', 'input[name^="Size-"]', function () {
//     $('.product-details_add-cart').addClass('active');
//     $('.size-guide').addClass('active');
//     $('.product-details_seclect-size').removeClass('active');
//     document.querySelector('.estimatedDeliveryWrapper').style.display = 'block';
//   });

//   // Observe pickup-availability section for DOM changes (no syncActiveClass anymore)
//   const observer = new MutationObserver(() => {
//     setTimeout(() => {
//       // No syncing needed anymore
//     }, 50);
//   });

//   function observePickupSection() {
//     const section = document.querySelector('pickup-availability') 
//       || document.querySelector('[data-section-id*="pickup-availability"]');

//     if (section) {
//       observer.observe(section, { childList: true, subtree: true });
//     }
//   }

//   // Run on page load
//   observePickupSection();

//   // No more setInterval syncing!
// });


// ############################################### product card varient img switcher #########################################


// document.addEventListener('DOMContentLoaded', function () {
//     document.addEventListener('click', function(event) {
//         const variantImg = event.target.closest('.product-card-varient-img img');
//         if (variantImg) {
//             const productCard = variantImg.closest('.product-card');
//             if (productCard) {
//                 // 1. Update the main image
//                 const mainImg = productCard.querySelector('.card-main-img');
//                 if (mainImg) {
//                     const baseSrc = variantImg.getAttribute('src').split('?')[0];
//                     const newSrc = `${baseSrc}?width=533`;
//                     const newSrcset = `${baseSrc}?width=360 360w, ${baseSrc}?width=533 533w, ${baseSrc}?width=720 720w`;

//                     mainImg.src = newSrc;
//                     mainImg.srcset = newSrcset;

//                     if (mainImg.hasAttribute('data-src')) {
//                         mainImg.setAttribute('data-src', newSrc);
//                     }
//                 }

//                 // 2. Update <source> tags inside <picture>
//                 const picture = productCard.querySelector('picture');
//                 if (picture) {
//                     const sources = picture.querySelectorAll('source');
//                     sources.forEach((source, index) => {
//                         let width = index === 0 ? 360 : 533; // Example: adjust per media rule
//                         const baseSrc = variantImg.getAttribute('src').split('?')[0];
//                         source.setAttribute('srcset', `${baseSrc}?width=${width}`);
//                     });
//                 }
//             }
//         }
//     });
// });

// document.addEventListener('DOMContentLoaded', function () {
//     document.addEventListener('click', function(event) {
//         const variantImg = event.target.closest('.product-card-varient-img img');
//         if (variantImg) {
//             const productCard = variantImg.closest('.product-card');
//             if (productCard) {
//                 const mainImg = productCard.querySelector('.card-main-img');
//                 if (mainImg) {
//                     const baseSrc = variantImg.getAttribute('data-img-src').split('?')[0];
//                     const newSrc = `${baseSrc}?width=533`;
//                     const newSrcset = `${baseSrc}?width=360 360w, ${baseSrc}?width=533 533w, ${baseSrc}?width=720 720w`;

//                     // Fade-slide animation setup
//                     mainImg.classList.remove('animate-fade-slide'); // reset if already animating
//                     void mainImg.offsetWidth; // reflow trick to restart animation

//                     // Update src/srcset
//                     mainImg.src = newSrc;
//                     mainImg.srcset = newSrcset;
//                     if (mainImg.hasAttribute('data-src')) {
//                         mainImg.setAttribute('data-src', newSrc);
//                     }

//                     // Apply animation
//                     mainImg.classList.add('animate-fade-slide');
//                 }

//                 const picture = productCard.querySelector('picture');
//                 if (picture) {
//                     const sources = picture.querySelectorAll('source');
//                     sources.forEach((source, index) => {
//                         let width = index === 0 ? 360 : 533;
//                         const baseSrc = variantImg.getAttribute('data-img-src').split('?')[0];
//                         source.setAttribute('srcset', `${baseSrc}?width=${width}`);
//                     });
//                 }
//             }
//         }
//     });
// });

document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('click', function(event) {
        const variantImg = event.target.closest('.product-card-varient-img img');
        if (variantImg) {
            variantImg.style.opacity = 0.6;
            const productCard = variantImg.closest('.product-card');
            if (productCard) {
                const mainImg = productCard.querySelector('.card-main-img');
                const hoverImg = productCard.querySelector('.card-hover-img');
                const darkMainImg = productCard.querySelector('.card-dark-main-img');
                const darkHoverImg = productCard.querySelector('.card-dark-hover-img');
                const picture = productCard.querySelector('picture');
                window.LOTTO_DEBUG&&console.log(`hoverimg ${hoverImg}`)
                if (mainImg) {
                    const baseSrc = variantImg.getAttribute('data-img-src').split('?')[0];
                    const newSrc = `${baseSrc}?width=360`;
                    const newSrcset = `${baseSrc}?width=360 360w, ${baseSrc}?width=533 533w, ${baseSrc}?width=360 360w`;

                    // Preload the image first
                    const tempImg = new Image();
                    tempImg.src = newSrc;
                    tempImg.srcset = newSrcset;

                    tempImg.onload = function () {
                        // Only update after load
                        mainImg.src = newSrc;
                        mainImg.srcset = newSrcset;
                        if (mainImg.hasAttribute('data-src')) {
                            mainImg.setAttribute('data-src', newSrc);
                        }

                        // Reset animation
                        mainImg.classList.remove('animate-fade-slide');
                        void mainImg.offsetWidth; // Reflow
                        mainImg.classList.add('animate-fade-slide');
                        variantImg.style.opacity = 1;
                    };
                }
                if (hoverImg) {
                    const hoverBaseSrc = variantImg.getAttribute('data-back-img-src')?.split('?')[0];
                    window.LOTTO_DEBUG&&console.log(`hoverbased src img ${hoverBaseSrc}`)
                    if (hoverBaseSrc) {  // only run if you actually have a back image
                        const newHoverSrc = `${hoverBaseSrc}?width=360`;
                        const newHoverSrcset = `${hoverBaseSrc}?width=360 360w, ${hoverBaseSrc}?width=533 533w, ${hoverBaseSrc}?width=720 720w`;

                        // Preload
                        const tempHover = new Image();
                        tempHover.src = newHoverSrc;
                        tempHover.srcset = newHoverSrcset;

                        tempHover.onload = function () {
                            hoverImg.src = newHoverSrc;
                            hoverImg.srcset = newHoverSrcset;
                            if (hoverImg.hasAttribute('data-src')) {
                                hoverImg.setAttribute('data-src', newHoverSrc);
                            }
                        };
                    }
                }
                if (darkMainImg) {
                    const baseSrc = variantImg.getAttribute('data-dark-img-src').split('?')[0];
                    const newSrc = `${baseSrc}?width=360`;
                    const newSrcset = `${baseSrc}?width=360 360w, ${baseSrc}?width=533 533w, ${baseSrc}?width=360 360w`;

                    // Preload the image first
                    const tempImg = new Image();
                    tempImg.src = newSrc;
                    tempImg.srcset = newSrcset;

                    tempImg.onload = function () {
                        // Only update after load
                        darkMainImg.src = newSrc;
                        darkMainImg.srcset = newSrcset;
                        if (darkMainImg.hasAttribute('data-src')) {
                            darkMainImg.setAttribute('data-src', newSrc);
                        }

                        // Reset animation
                        darkMainImg.classList.remove('animate-fade-slide');
                        void darkMainImg.offsetWidth; // Reflow
                        darkMainImg.classList.add('animate-fade-slide');
                        variantImg.style.opacity = 1;
                    };
                }
                if (darkHoverImg) {
                    const hoverBaseSrc = variantImg.getAttribute('data-dark-back-img-src')?.split('?')[0];
                    window.LOTTO_DEBUG&&console.log(`hoverbased src img ${hoverBaseSrc}`)
                    if (hoverBaseSrc) {  // only run if you actually have a back image
                        const newHoverSrc = `${hoverBaseSrc}?width=360`;
                        const newHoverSrcset = `${hoverBaseSrc}?width=360 360w, ${hoverBaseSrc}?width=533 533w, ${hoverBaseSrc}?width=720 720w`;

                        // Preload
                        const tempHover = new Image();
                        tempHover.src = newHoverSrc;
                        tempHover.srcset = newHoverSrcset;

                        tempHover.onload = function () {
                            darkHoverImg.src = newHoverSrc;
                            darkHoverImg.srcset = newHoverSrcset;
                            if (darkHoverImg.hasAttribute('data-src')) {
                                darkHoverImg.setAttribute('data-src', newHoverSrc);
                            }
                        };
                    }
                }

                // Update <picture><source> elements too
                if (picture) {
                    const sources = picture.querySelectorAll('source');
                    const baseSrc = variantImg.getAttribute('data-img-src').split('?')[0];
                    sources.forEach((source, index) => {
                        const width = index === 0 ? 360 : 533;
                        source.setAttribute('srcset', `${baseSrc}?width=${width}`);
                    });
                }
            }
        }
    });
});

// ############################## pdp varent click ##########################

  // document.addEventListener('DOMContentLoaded', function() {
  //   document.querySelectorAll('.product-variant-image').forEach(function(imageEl) {
  //     imageEl.addEventListener('click', function() {
  //       const optionId = imageEl.getAttribute('data-option-id');
  //       const targetInput = document.querySelector(`input[data-option-value-id="${optionId}"]`);
  //       if (targetInput) {
  //         targetInput.click();
  //       }
  //     });
  //   });
  // });

  document.addEventListener('DOMContentLoaded', function() {
    const variantImages = document.querySelectorAll('.product-variant-image');
    const enableLoader = document.querySelector('.product-details-left .slider-rl');

    variantImages.forEach(function(imageEl) {
      imageEl.addEventListener('click', function() {
        const optionId = imageEl.getAttribute('data-option-id');
        

        // Click the corresponding radio input
        const targetInput = document.querySelector(`input[data-option-value-id="${optionId}"]`);
        if (targetInput) {
          targetInput.click();
        }

        // Remove 'variant-active' from all images
        document.querySelectorAll('.product-variant-image.active').forEach(function(activeEl) {
          activeEl.classList.remove('active');
        });

        // Add 'variant-active' to the clicked image
        imageEl.classList.add('active');
        enableLoader.classList.add('loading');
      });
    });
  });


// ############################### inisilse the sorting in plp #############



  // // reinislization is done by the facets.js vis static renderProductGridContainer(html) function
  // window.addEventListener('load', function() {
  //   const $select = $('.select-sorting');

  //   $select.select2({
  //     placeholder: "Sort by",
  //     allowClear: true
  //   });

  //   $select.on('change', function() {
  //     // Trigger native input event on the parent form
  //     const form = this.closest('form');
  //     if (form) {
  //       form.dispatchEvent(new Event('input', { bubbles: true }));
  //     }
  //   });
  // });

// window.addEventListener('load', function () {
//   const $select = $('.select-sorting');

//   // Remove any selected attribute from options to show placeholder
//   $select.find('option[selected]').removeAttr('selected');

//   // Set the value to empty to trigger placeholder
//   $select.val('');

//   $select.select2({
//     placeholder: "Sort by",
//     allowClear: true,
//     minimumResultsForSearch: Infinity
//   });
//   $select.on('change', function () {
//     const sortForm = this.closest('form');
//     const filtersForm = document.querySelector('#FacetFiltersForm');
//     const mobileFiltersForm = document.querySelector('#FacetFiltersFormMobile');
//     const drawerSortForm = document.querySelector('#FacetSortDrawerForm');
//     const mainSortForm = document.querySelector('#FacetSortForm');
//     // Use FormData to collect params
//     const params = new URLSearchParams();
  
//     // Collect all relevant forms
//     const formsToMerge = [sortForm, filtersForm, mobileFiltersForm, drawerSortForm, mainSortForm].filter(Boolean);
  
//     formsToMerge.forEach(form => {
//       const formData = new FormData(form);
//       for (const [key, value] of formData.entries()) {
//         // Avoid duplicate params
//         if (value && !params.has(key)) {
//           params.append(key, value);
//         }
//       }
//     });
  
//     // Final merged search string
//     const searchParams = params.toString();
  
//     // Render the updated filtered/sorted products
//     FacetFiltersForm.renderPage(searchParams, null);
//   });

//   // $select.on('change', function () {
//   //   // Trigger native input event on the parent form
//   //   const form = this.closest('form');
//   //   if (form) {
//   //     form.dispatchEvent(new Event('input', { bubbles: true }));
//   //   }
//   // });
// });
window.addEventListener('load', function () {
  const $select = $('.select-sorting');

  if (!$select.length) return;

  // Reset selection (for placeholder)
  $select.find('option[selected]').removeAttr('selected');
  $select.val('');

  // ✅ Check if select2 exists before calling it
  if ($.fn && typeof $.fn.select2 === 'function') {
    $select.select2({
      placeholder: "Sort by",
      allowClear: true,
      minimumResultsForSearch: Infinity
    });
  } else {
    console.warn('Select2 is not loaded — falling back to default select');
  }

  // ✅ This will ALWAYS work now
  $select.on('change', function () {
    const sortForm = this.closest('form');
    const filtersForm = document.querySelector('#FacetFiltersForm');
    const mobileFiltersForm = document.querySelector('#FacetFiltersFormMobile');
    const drawerSortForm = document.querySelector('#FacetSortDrawerForm');
    const mainSortForm = document.querySelector('#FacetSortForm');

    const params = new URLSearchParams();

    const formsToMerge = [
      sortForm,
      filtersForm,
      mobileFiltersForm,
      drawerSortForm,
      mainSortForm
    ].filter(Boolean);

    formsToMerge.forEach(form => {
      const formData = new FormData(form);
      for (const [key, value] of formData.entries()) {
        if (value && !params.has(key)) {
          params.append(key, value);
        }
      }
    });

    const searchParams = params.toString();

    FacetFiltersForm.renderPage(searchParams, null);
  });
});

//  ############################### plp page see more button #######################

// document.addEventListener("DOMContentLoaded", function () {
//   const loadMoreBtn = document.querySelector('.load-more-btn');

//   if (loadMoreBtn) {
//     loadMoreBtn.addEventListener('click', function () {
//       const nextUrl = loadMoreBtn.getAttribute('data-next-url');

//       fetch(nextUrl)
//         .then(response => response.text())
//         .then(html => {
//           // Create a temporary DOM to parse the fetched HTML
//           const parser = new DOMParser();
//           const doc = parser.parseFromString(html, 'text/html');

//           // Get the product grid from the next page
//           const newProducts = doc.querySelector('#product-grid');
//           const currentGrid = document.querySelector('#product-grid');

//           if (newProducts && currentGrid) {
//             currentGrid.innerHTML += newProducts.innerHTML;
//           }

//           // Update the next URL or remove the button
//           const newButton = doc.querySelector('.load-more-btn');
//           if (newButton) {
//             loadMoreBtn.setAttribute('data-next-url', newButton.getAttribute('data-next-url'));
//           } else {
//             loadMoreBtn.remove();
//           }
//         })
//         .catch(error => {
//           console.error('Load more failed:', error);
//           loadMoreBtn.textContent = 'Failed to load';
//         });
//     });
//   }
// });
//  ############################### plp page see more button with count parse #######################
function setPresetPrice(min, max) {
  const rangeInputs = document.querySelectorAll(".range-input input");
  const priceInputs = document.querySelectorAll(".price-input input");
  const rangeBar = document.querySelector(".slider .price-slider");

  if (!rangeInputs.length || !priceInputs.length) return;

  const maxRange = parseInt(rangeInputs[0].max);

  if (max === 'max') {
    max = maxRange;
  }

  // Set slider values
  rangeInputs[0].value = min;
  rangeInputs[1].value = max;

  // Set input field values
  priceInputs[0].value = min;
  priceInputs[1].value = max;

  // Update slider UI
  rangeBar.style.left = `${(min / maxRange) * 100}%`;
  rangeBar.style.right = `${100 - (max / maxRange) * 100}%`;

  // Trigger Shopify filter AJAX
  const form = document.querySelector('#FacetFiltersForm');
  if (form) {
    form.dispatchEvent(new Event('input', { bubbles: true }));
  }
}
// Shared, viewport-lazy, concurrency-capped loader for product-card variant swatches.
// Each swatch ships with empty src + data-handle; its thumbnail lives on a sibling
// product and must be fetched. Fetching all (hundreds/page) at once triggers Shopify
// 429s, so we observe each swatch and, on scroll-into-view, queue a fetch processed
// at most CONCURRENCY at a time, deduped by handle. State lives on window so the
// duplicate caller (FacetFiltersForm.loadAjaxImages) never double-fetches.
function spectrumLoadSwatchImages(){
  var CONCURRENCY = 4;
  var cache = (window.__saiSwatchCache = window.__saiSwatchCache || {});
  var queue = (window.__saiSwatchQueue = window.__saiSwatchQueue || []);
  if (window.__saiSwatchInFlight == null) window.__saiSwatchInFlight = 0;

  function fetchData(handle){
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + handle + '?section_id=plp-img')
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (t) {
        var el = new DOMParser().parseFromString(t, 'text/html').querySelector('.image');
        return el ? {
          src: el.getAttribute('data-src'),
          img: el.getAttribute('data-img-src'),
          back: el.getAttribute('data-back-img-src'),
          dark: el.getAttribute('data-dark-img-src'),
          darkBack: el.getAttribute('data-dark-back-img-src')
        } : null;
      })
      .catch(function () { return null; });
    return cache[handle];
  }
  function apply(img, d){
    if (!d || !d.src) return;
    img.src = d.src;
    img.setAttribute('data-src', d.src);
    if (d.img) img.setAttribute('data-img-src', d.img);
    if (d.back) img.setAttribute('data-back-img-src', d.back);
    if (d.dark) img.setAttribute('data-dark-img-src', d.dark);
    if (d.darkBack) img.setAttribute('data-dark-back-img-src', d.darkBack);
  }
  function release(){ window.__saiSwatchInFlight--; pump(); }
  function pump(){
    while (window.__saiSwatchInFlight < CONCURRENCY && queue.length) {
      var img = queue.shift();
      var handle = img.getAttribute('data-handle');
      if (!handle) continue;
      window.__saiSwatchInFlight++;
      (function (el) {
        fetchData(el.getAttribute('data-handle')).then(function (d) { apply(el, d); }).then(release, release);
      })(img);
    }
  }
  function enqueue(img){ queue.push(img); pump(); }

  if (!window.__saiSwatchIO && typeof IntersectionObserver !== 'undefined') {
    window.__saiSwatchIO = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { obs.unobserve(e.target); enqueue(e.target); }
      });
    }, { rootMargin: '200px 0px' });
  }
  var vh = window.innerHeight || document.documentElement.clientHeight;
  document.querySelectorAll('.ajaxLoad').forEach(function (img) {
    if (img.getAttribute('data-sai-observed')) return;
    img.setAttribute('data-sai-observed', '1');
    // Already in/near the viewport (e.g. swatches in a freshly filter-rendered grid):
    // enqueue now rather than waiting on the observer, which may not fire for nodes
    // inserted already in their final position. Off-screen swatches are observed and
    // load lazily on scroll. The concurrency cap still bounds in-flight requests.
    var r = img.getBoundingClientRect();
    var nearView = r.bottom > -200 && r.top < vh + 200;
    if (nearView || !window.__saiSwatchIO) {
      enqueue(img);
    } else {
      window.__saiSwatchIO.observe(img);
    }
  });
}
function loadAjaxImages(){ spectrumLoadSwatchImages(); }
function loadpaginate() {
  const loadMoreBtn = document.querySelector('.load-more-btn');
  const productGrid = document.querySelector('#product-grid');
  const shownCountEl = document.getElementById('shown-count');
  const totalCountEl = document.getElementById('total-count');
  const paginationCount = document.querySelector('.product-pagination-count');

  if (!loadMoreBtn || !productGrid) return;

  const nextUrl = loadMoreBtn.getAttribute('data-next-url');
  loadMoreBtn.classList.add('loading');

  fetch(nextUrl)
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newGrid = doc.querySelector('#product-grid');
      const newButton = doc.querySelector('.load-more-btn');
      const newPaginationCount = doc.querySelector('.product-pagination-count');

      if (newPaginationCount) {
        paginationCount.setAttribute('data-total-count', newPaginationCount.getAttribute('data-total-count'));
        paginationCount.setAttribute('data-show-count', newPaginationCount.getAttribute('data-show-count'));
        
        if (shownCountEl) {
          shownCountEl.textContent = paginationCount.getAttribute('data-show-count');
        }
        if (totalCountEl) {
          totalCountEl.textContent = paginationCount.getAttribute('data-total-count');
        }
      } else if (shownCountEl) {
        shownCountEl.textContent = paginationCount.getAttribute('data-total-count');
      }

      if (newGrid && productGrid) {
        productGrid.innerHTML += newGrid.innerHTML;
        try {
          loadAjaxImages();
          initWishlist();
          loadWishListProducts();
        } catch(err) {}
      }

      // Sync the page number into the URL as pages append (?page=N), so the URL is
      // shareable and reflects how far the customer has loaded. replaceState (not push)
      // keeps the back button pointing at where they arrived from, not each scroll step.
      // Preserves any active filter/sort params — nextUrl already carries them.
      if (window.history && history.replaceState) {
        try { history.replaceState(history.state, '', nextUrl); } catch (e) {}
      }

      if (newButton) {
        var upcomingUrl = newButton.getAttribute('data-next-url');
        loadMoreBtn.setAttribute('data-next-url', upcomingUrl);
        // Keep the crawlable href pointing at the NEXT page so the link chain and the
        // no-JS fallback advance in step with the data attribute.
        if (upcomingUrl) loadMoreBtn.setAttribute('href', upcomingUrl);
        loadMoreBtn.setAttribute('data-total-count', newButton.getAttribute('data-total-count'));
        loadMoreBtn.setAttribute('data-show-count', newButton.getAttribute('data-show-count'));
        loadMoreBtn.classList.remove('loading');
      } else {
        loadMoreBtn.remove();
      }
    })
    .catch(error => {
      console.error('Load more failed:', error);
      loadMoreBtn.textContent = 'Failed to load';
    });
}
function infiniteScrollHandler() {
  const loadMoreBtn = document.querySelector('.load-more-btn');
  if (!loadMoreBtn || loadMoreBtn.classList.contains('loading')) return;

  const rect = loadMoreBtn.getBoundingClientRect();
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;

  // When button is within 500px of viewport bottom
  if (rect.top <= windowHeight + 500) {
    loadpaginate();
  }
}
// document.addEventListener("DOMContentLoaded", function () {
//   const loadMoreBtn = document.querySelector('.load-more-btn'); // correct class from your HTML
//   const productGrid = document.querySelector('#product-grid');
//   const shownCountEl = document.getElementById('shown-count');
//   const totalCountEl = document.getElementById('total-count');
//   const paginationCount = document.querySelector('.product-pagination-count');
  
//   if (loadMoreBtn && productGrid) {
//     loadMoreBtn.addEventListener('click', function loadpaginate() {
//       const nextUrl = loadMoreBtn.getAttribute('data-next-url');
//       loadMoreBtn.classList.add('loading');
//       fetch(nextUrl)
//         .then(response => response.text())
//         .then(html => {
//           const parser = new DOMParser();
//           const doc = parser.parseFromString(html, 'text/html');

//           const newGrid = doc.querySelector('#product-grid');
//           const newButton = doc.querySelector('.load-more-btn');
//           const newPaginationCount = doc.querySelector('.product-pagination-count');
//           if (newPaginationCount){
//               // paginationCount.innerHTML = newPaginationCount.innerHTML;
//               paginationCount.setAttribute('data-total-count', newPaginationCount.getAttribute('data-total-count'));
//               paginationCount.setAttribute('data-show-count', newPaginationCount.getAttribute('data-show-count'));
//               // ✅ Update shown count
//               if (shownCountEl) {
//                 const showCountData = paginationCount.getAttribute('data-show-count');
//                 // shownCountEl.textContent = productGrid.children.length;
//                 shownCountEl.textContent = showCountData;
//               }
//               if (totalCountEl) {
//                 const totalCountData = paginationCount.getAttribute('data-total-count');
//                 // shownCountEl.textContent = productGrid.children.length;
//                 totalCountEl.textContent = totalCountData;
//               }
//           } else if(shownCountEl){
//             const showCountData = paginationCount.getAttribute('data-total-count');
//             shownCountEl.textContent = showCountData;
//           }
//           if (newGrid && productGrid) {
//             productGrid.innerHTML += newGrid.innerHTML;

//           try{
//             loadAjaxImages();  
//           }catch(err){}
          

            
            
            
            
//             // ✅ Update shown count
//             // if (shownCountEl) {
//             //   const showCountData = loadMoreBtn.getAttribute('data-show-count');
//             //   // shownCountEl.textContent = productGrid.children.length;
//             //   shownCountEl.textContent = showCountData;
//             // }
//             // if (totalCountEl) {
//             //   const totalCountData = loadMoreBtn.getAttribute('data-total-count');
//             //   // shownCountEl.textContent = productGrid.children.length;
//             //   totalCountEl.textContent = totalCountData;
//             // }
//           }

//           // ✅ Update or remove the button
//           if (newButton) {
//             loadMoreBtn.setAttribute('data-next-url', newButton.getAttribute('data-next-url'));
//             loadMoreBtn.setAttribute('data-total-count', newButton.getAttribute('data-total-count'));
//             loadMoreBtn.setAttribute('data-show-count', newButton.getAttribute('data-show-count'));
            
//             loadMoreBtn.classList.remove('loading');
//           } else {
//             loadMoreBtn.remove();
//           }
//         })
//         .catch(error => {
//           console.error('Load more failed:', error);
//           loadMoreBtn.textContent = 'Failed to load';
//         });
//     });
//   }
// });


// ################################## filter price range sync ###############




function handlePopup(id,close){
    var popupWrapper = document.getElementById(id);
    document.querySelector('body').classList.add('overflow-hidden');
    if(close === true){
      popupWrapper.style.display = 'none';
      document.querySelector('body').classList.remove('overflow-hidden');
      return true;
    }
    popupWrapper.style.display = 'block';
  
}

// ############################################ plp mobile filter close ########################

document.addEventListener('DOMContentLoaded', function () {
  if (!('ontouchstart' in window)) return;

  const scrollDisable = document.querySelector('body');
  const detailsEl = document.querySelector('.mobile-facets__disclosure');
  const animateContainer = document.querySelector('.mobile-facets__inner');
  const scrollContainer = document.getElementById('FacetsWrapperMobile');

  if (!detailsEl || !animateContainer || !scrollContainer) return;

  let startY = 0;
  let isDragging = false;
  let pulledDown = 0;
  const closingThreshold = 100;

  animateContainer.style.transition = 'transform 0.3s ease';

  scrollContainer.addEventListener('touchstart', function (e) {
    if (scrollContainer.scrollTop === 0) {
      startY = e.touches[0].clientY;
      isDragging = true;
      pulledDown = 0;
      animateContainer.style.transition = 'none';
    }
  });

  scrollContainer.addEventListener('touchmove', function (e) {
    if (!isDragging) return;

    const currentY = e.touches[0].clientY;
    const deltaY = currentY - startY;

    if (deltaY > 0 && scrollContainer.scrollTop === 0) {
      pulledDown = deltaY;
      animateContainer.style.transform = `translateY(${deltaY}px)`;
    }
  });

  scrollContainer.addEventListener('touchend', function () {
    if (!isDragging) return;
    isDragging = false;

    animateContainer.style.transition = 'transform 0.3s ease';

    if (pulledDown > closingThreshold) {
      // Animate out and close
      animateContainer.style.transform = `translateY(100%)`;

      setTimeout(() => {
        detailsEl.removeAttribute('open');
        detailsEl.classList.remove('menu-opening');
        scrollDisable.classList.remove('overflow-hidden-mobile');
        animateContainer.style.transform = '';
      }, 300);
    } else {
      // Revert to original position
      animateContainer.style.transform = '';
    }
  });
});

// kwikpass login for account 

function handleAccountClick(event) {
  event.preventDefault();

  const customerId = getCustomerId();
  const tokenkp = getValueFromCookiesOrLocalStorage(
    XGokwikCoreToken(window.merchantInfo.environment)
  );

  if (tokenkp && customerId != null) {
    window.location.href = "/account";
  } else {
    handleKpAndShopifyLogin("/account");
  }
}


document.addEventListener("DOMContentLoaded", () => {
  // const errorEl = document.querySelector(".select-size-err");
  const productForms = document.querySelectorAll("product-form");

  productForms.forEach((productForm) => {
    const submitButton = productForm.querySelector(".product-form__submit");
    const varientIdEle = productForm.querySelector(".product-variant-id");
    window.LOTTO_DEBUG&&console.log("submit buttion pdp",submitButton)

      subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
        window.LOTTO_DEBUG&&console.warn("Variant selected:", event);
        submitButton.classList.remove('atc-disable');
      });
    if (!submitButton) return;

    // ✅ 1. Handle click when variant not selected
    
    submitButton.addEventListener("click", (e) => {
      // Only trigger error if button type is "button"
      if (submitButton.getAttribute("type") === "button") {
        e.preventDefault();
        if (errorEl) {
          errorEl.classList.add("active");
          window.LOTTO_DEBUG&&console.log("Variant not selected → showing error");
        }
      }
    });
  });
});
async function buyNowPdp(button, vId){
    let varientId = button.getAttribute("data-variant-id")|| vId ;
    window.LOTTO_DEBUG&&console.warn('varientId', varientId );
    // Require an actively-chosen size before checkout. data-variant-id can be
    // pre-populated from a ?variant= URL (a size carried across a colour switch, or a
    // deep link) while the size pill is left visually unselected — trusting it alone
    // would check out a size the shopper never picked. Gate on the real selection,
    // matching the Add-to-Bag gate in product-form.js, and move focus to the error
    // (role="alert", tabindex="-1") for keyboard/screen-reader users.
    const sizeInputs = document.querySelectorAll('input[name^="Size-"]');
    const sizeChosen = document.querySelector('input[name^="Size-"]:checked');
    // If the shopper picked a size but the variant is still resolving from a size
    // change, wait for it so data-variant-id reflects the chosen size before we
    // gate/checkout — otherwise the first tap fails (empty id) or checks out a stale
    // size. Show the button spinner during the wait.
    const resolvingVariant = (button.closest('product-info') || document.querySelector('product-info'))?.pendingVariantUpdate;
    if (sizeChosen && resolvingVariant) {
      button.classList.add('loading');
      button.disabled = true;
      try { await resolvingVariant; } catch (e) {}
      button.classList.remove('loading');
      button.disabled = false;
      varientId = button.getAttribute("data-variant-id") || vId;
    }
    if ((sizeInputs.length > 0 && !sizeChosen) || !varientId){
      const sizeErr = document.querySelector(".select-size-err");
      if (sizeErr) { sizeErr.classList.add('active'); sizeErr.focus(); }
      return;
    }
    // Show the button spinner while GoKwik initialises checkout, then clear it —
    // onBuyNowClick resolves once the checkout modal is up. Mirrors quickBuyNow so the
    // Buy Now button gives immediate feedback instead of looking dead until GoKwik paints.
    button.classList.add('loading');
    button.disabled = true;
    try {
      await onBuyNowClick(button.event, false, [{ id: varientId, quantity: 1 }]);
    } catch (e) {
      window.LOTTO_DEBUG && console.error('Buy Now error:', e);
    } finally {
      button.classList.remove('loading');
      button.disabled = false;
    }
}
  function toggleProductCardActive(button) {
    const card = button.closest('.product-card');

    // Remove active class from all other cards
    document.querySelectorAll('.product-card').forEach(c => {
      if (c !== card) c.classList.remove('active');
    });

    // Toggle active on the clicked one
    card.classList.toggle('active');
  }
// plp add to cart button function
function plpAtc(button){
  var vid = button.getAttribute('data-vid');
  var handle = button.getAttribute('data-handle');
  button.classList.add('loading');
  button.setAttribute('disabled',1);
  fetch('/cart/add.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({id: vid, quantity: 1 }),
	})
	.then(response => response.json())
	.then(data => {
        fetch('/cart.js').then((response) => response.json()).then((response) => {
          window.LOTTO_DEBUG&&console.log(response)
          document.querySelectorAll('.cart-count-bubble span').forEach(function(span){
            span.innerHTML = response.item_count;
          })
        })
		    // Optionally, update the UI or redirect to the cart page
         //removeToWishlist(button,true,false,true)
          productToast({
            handle: handle,
            vid: vid
          });
      button.classList.remove('loading');
      button.removeAttribute('disabled',1)
      // loadWishListProducts();
      displayUserWishlist();
	})
	.catch(error => {
		console.error('Error adding product to cart:', error);
      button.classList.remove('loading');
      button.removeAttribute('disabled',1)
      //button.removeClass('loading');
	});
  //window.location.href = `/products/${handle}?variant=${vid}`
}

function ginzaATCOpen(button, targetId) {
  // Remove active from all ATC containers
  document.querySelectorAll('[id$="_plp-atc"]').forEach(el => {
    el.classList.remove('active');
  });

  // Remove active from all buttons
  document.querySelectorAll('.ginza-atc-btn').forEach(btn => {
    btn.classList.remove('active');
  });

  // Add active to selected div
  const target = document.getElementById(targetId);
  if (target) {
    target.classList.add('active');
  }

  // Add active to clicked button
  if (button) {
    button.classList.add('active');
  }
}
document.querySelectorAll('.option-dropdown').forEach(dropdown => {
  dropdown.addEventListener('mouseleave', function () {
    this.classList.remove('active');

    // Also remove active from related button
    document.querySelectorAll('.lotto-ginza-atc-btn-desktop').forEach(btn => {
      btn.classList.remove('active');
    });
  });
});

/* ── for slider Scroll / trackpad support ──────────────────────────── */
function addSlickScrollSupport($slider, cooldown) {
  // Delegated + non-passive: one wheel listener on document resolves whichever
  // ginza slider is currently in the DOM via closest(). The old binding sat on
  // the slider element, which is torn down + re-slicked during a variant/color
  // swap, so it was lost after switching articles. Delegation survives that.
  // passive:false is required so preventDefault can hijack scroll into a slide
  // (Chrome makes document wheel listeners passive by default otherwise).
  cooldown = cooldown || 400;
  if (window.__ginzaWheelBound) return;
  window.__ginzaWheelBound = true;

  var timer = null;
  var busy  = false;

  document.addEventListener('wheel', function(e) {
    var node = e.target && e.target.closest && e.target.closest('.product-ginza-slider, .product-dark-ginza-slider');
    if (!node) return;
    var $s = jQuery(node);
    if (!$s.hasClass('slick-initialized')) return;

    e.preventDefault();
    if (busy) return;

    var delta = e.deltaX || e.deltaY;
    if      (delta > 0) $s.slick('slickNext');
    else if (delta < 0) $s.slick('slickPrev');

    busy = true;
    clearTimeout(timer);
    timer = setTimeout(function() { busy = false; }, cooldown);
  }, { passive: false });
}

// function toggleTheme(el) {
//     el.classList.toggle('active');   // active on clicked element
//     document.body.classList.toggle('dark-theme');
// }
// (function () {
//     const savedTheme = localStorage.getItem('theme');
//     if (savedTheme === 'dark') {
//         document.documentElement.classList.add('dark-theme');
//     }
// })();
// function syncToggleUI() {
//   const btn = document.querySelector('.theme-switch');
//   if (!btn) return;
//   const isDark = document.documentElement.classList.contains('dark-theme');
//   // ensure body is also correct (important on load)
//   document.body.classList.toggle('dark-theme', isDark);
//   btn.classList.toggle('active', isDark);
// }
// function toggleTheme() {
//   document.body.classList.toggle('dark-theme');
//   document.documentElement.classList.toggle('dark-theme');
//   const isDark = document.body.classList.contains('dark-theme');
//   localStorage.setItem('theme', isDark ? 'dark' : 'light');
//   syncToggleUI();
// }